module.exports = __webpack_public_path__ + "static/img/4.607a53a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3/4.png
// module id = vzSA
// module chunks = 1